import { useState, useEffect } from "react";
import { useStateContext } from "../context/StateContext";


/**
 * Hook that returns the current network status.
 *
 * Returns true if the user is online, false otherwise.
 *
 * @returns {boolean} The current network status.
 */
const useNetworkStatus = () => {
  const [status, setStatus] = useState(navigator?.onLine);
  const { manualOffline } = useStateContext();

  useEffect(() => {
    const updateStatus = () => {
      if (manualOffline) {
        setStatus(false);
      } else {
        // When not manually offline, fall back to browser's online status
        setStatus(navigator?.onLine);
      }
    };

    const handleOnline = () => {
      if (!manualOffline) setStatus(true);
    };

    const handleOffline = () => {
      if (!manualOffline) setStatus(false);
    };

    // Initial check
    updateStatus();

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, [manualOffline]);

  return status;
};

export default useNetworkStatus;